// Which sidebar / bottom-nav menus each permission controls (see components/Layout/Layout.js).
// Shown in Users & Roles → Permissions so admins know that "Deny" hides the menu.
const menuPermissions = {
  "dashboard.view": ["Dashboard"],
  "profile.read": ["My Profile (members)"],
  "staff_profile.read": ["My Profile (staff)"],
  "id_cards.read": ["My ID", "Digital IDs"],
  "id_cards.manage": ["Card Templates"],
  "contributions.read": ["Contributions"],
  "loans.read": ["Loans"],
  "meetings.read": ["Meetings"],
  "elections.read": ["Elections"],
  "cases.read": ["Cases"],
  "cba.read": ["CBA Agreements"],
  "trainings.read": ["Trainings"],
  "engagement.read": ["Engagement"],
  "ai.use": ["AI Assistant"],
  "documents.read": ["Document Library"],
  "support.read": ["Help & Support"],
  "communications.read": ["Messages"],
  "members.read": ["Members"],
  "branches.read": ["Branches"],
  "finance.read": ["Accounting"],
  "requisitions.read": ["Requisition Register"],
  "reports.read": ["Reports"],
  "recruitment.read": ["Recruitment"],
};

export default menuPermissions;
